import MiSeparator from './MiSeparator.vue'

export default MiSeparator
